export const SET_FULL_INFO = 'SET_FULL_INFO'
export const MERGE_INFO = 'MERGE_INFO'
export const SET_CURRENT = 'SET_CURRENT'

export default {
    SET_FULL_INFO, MERGE_INFO,
    SET_CURRENT
}
